import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface DbArticle {
  id: string
  user_id: string
  url: string
  title: string | null
  content: string | null
  excerpt: string | null
  word_count: number | null
  source_type: 'article' | 'youtube' | 'pdf' | 'newsletter'
  source_metadata: Record<string, unknown>
  is_read: boolean
  is_favorite: boolean
  is_archived: boolean
  archived_at: string | null
  reading_progress: number
  scroll_position: number
  ai_summary: Record<string, unknown> | null
  chat_history: unknown[]
  snoozed_until: string | null
  device_id: string | null
  created_at: string
  updated_at: string
}

export interface DbHighlight {
  id: string
  user_id: string
  article_id: string
  text_content: string
  start_offset: number
  end_offset: number
  color: string
  note: string | null
  created_at: string
  updated_at: string
}

export interface DbProfile {
  id: string
  email: string | null
  display_name: string | null
  avatar_url: string | null
  created_at: string
  updated_at: string
}

export interface DbCollection {
  id: string
  user_id: string
  name: string
  description: string | null
  color: string
  share_token: string | null
  is_public: boolean
  shared_at: string | null
  created_at: string
  updated_at: string
}

export interface DbArticleCollection {
  article_id: string
  collection_id: string
  created_at: string
}

// AI Extract types
export type ExtractType = 'summary' | 'key_points' | 'flashcards' | 'synthesis'

export interface KeyPoint {
  id: string
  text: string
  importance: 'high' | 'medium' | 'low'
}

export interface Flashcard {
  id: string
  front: string
  back: string
  tags?: string[]
}

export interface AISummary {
  brief: string           // 1-2 sentence summary
  detailed: string        // Full paragraph summary
  keyPoints: KeyPoint[]
  flashcards: Flashcard[]
  generatedAt: string
  model: string          // Which AI model was used
}

export interface DbSharedExtract {
  id: string
  user_id: string
  article_id: string
  extract_type: ExtractType
  content: {
    title: string
    extractContent: string | KeyPoint[] | Flashcard[]
    sourceTitle: string
    sourceUrl: string
    sourceExcerpt?: string
  }
  share_token: string
  view_count: number
  is_public: boolean
  expires_at: string | null
  created_at: string
  updated_at: string
}

// Helper to generate share token
export function generateShareToken(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'
  let token = ''
  for (let i = 0; i < 12; i++) {
    token += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return token
}
